<template>
    <div class="info-help">
        <div class="infobody-help">
            <div class="white-header">
                <div class="tenforty-wrap">
                    <router-link :to="$homeLink" class="c-back__box">
                        <span class="c-back__icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="14px">
                                <path
                                    d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z">
                                </path>
                            </svg>
                        </span>
                        <div>Return to info.my.vermont.gov</div>
                    </router-link>
                    <h1>Vermont Department of Labor<br />myVermont Login Support!</h1>
                    <div class="sub-headings">
                        <p><b>How can we help you?</b></p>
                        <div class="error-redirect-box" v-if="error == 'general'">
                            There was an issue logging you into claimant portal.
                            Please try again at <a class="email-link" href="https://claimantportal.labor.vermont.gov">claimantportal.labor.vermont.gov</a>. If that is unsuccessful, please reach out to support as provided below.
                        </div>
                        <div v-else class="image-row">
                            <img class="help-icon" src="../../assets/supportMoney.png" />
                            <p class="heading-instruction">Please read the common issues and solutions below before
                                contacting our local job centers.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tenforty-wrap">

                <h2 class="faq-header">How to Register for Unemployment Insurance Benefits</h2>
                <p class="faq-text">A myVermont account allows you to file an unemployment insurance claim with the
                    Vermont Department of Labor ("VDOL"), as well as access other state resources. If you do not already
                    have a myVermont account, you will be prompted to create one when filing your unemployment insurance
                    claim. To file your claim, visit Claimant e-Services at
                    <a class="email-link" href="https://labor.ui.vermont.gov/UI/Claimant">labor.ui.vermont.gov/UI/Claimant</a>.
                    As part of the registration process, VDOL will send you an activation email to complete your
                    myVermont account set up. If you do not receive the email, please contact your local Job Center
                    using the contact information in the "Need Additional Support?" section below.
                </p>

                <h2 class="faq-header">How to Access an Employer Account</h2>
                <p class="faq-text">A myVermont account allows you to access your account with the Vermont Department
                    of Labor ("VDOL"), as well as access other state resources. If you do not already have a myVermont
                    account, you will be prompted to create one when establishing an Employer e-Services account. To
                    create your account, visit Employer e-Services at
                    <a class="email-link" href="https://labor.ui.vermont.gov/UI/Employer">labor.ui.vermont.gov/UI/Employer</a>.
                    As part of the account registration, VDOL will send you an activation email to complete your
                    myVermont account setup. If you do not receive the email, please contact your local Job Center
                    using the contact information in the "Need Additional Support?" section below.
                </p>

                <!-- HelpMFABlock differences vs. the VDOL help doc:
                     - Component adds a "Why is MFA important?" paragraph not in the doc
                     - Component adds a router-link to /help-mfa not in the doc
                     - Doc mentions "physical security key" as an option; component does not
                     - Lost-device text says "contact support for the program" rather than Job Centers specifically -->
                <HelpMFABlock
                    :envLinks="envLinks"
                    appsRequiring="VDOL applications"
                    mfaSupportText="You will need to contact your local Job Center using the contact information in the 'Need Additional Support?' section below.">
                </HelpMFABlock>

                <HelpGeneral :envLinks="envLinks"></HelpGeneral>

                <div class="noteAlt">
                    <i><font-awesome-icon icon="info-circle" /></i>
                    <div class="noteText">
                        <p><b>Need Additional Support?</b></p>
                        <p>If you need assistance, Vermont Job Centers are available to help customers directly. You may
                            call or visit a local Job Center Monday through Thursday from 9:00 a.m. to 4:00 p.m., or on
                            Fridays by appointment only. We encourage you to contact your local Job Center in advance to
                            schedule an appointment.
                        </p>
                        <p>
                            <a rel="noopener" target="_blank"
                                href="https://labor.vermont.gov/workforce-development/job-centers">Find a local Job Center at Department of Labor Job Centers.</a>
                        </p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import HelpGeneral from './HelpGeneral'
import HelpMFABlock from './HelpMFABlock.vue'

export default {
    name: 'help-vdol',
    props: ['envLinks'],
    components: { HelpGeneral, HelpMFABlock },
    data() {
        return {
            error: ""
        }
    },
    created() {
        const queryString = window.location.search
        const urlParams = new URLSearchParams(queryString)
        this.error = urlParams.get('error')
    }
}
</script>

<style scoped>
@import './help.css';
</style>
